(function() {
    angular
        .module("devicesModule", [
            "ui.router",
            "googlechart",
            "ui.calendar"
        ])
})()
